/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FreecardData as AgentApiContractFreecardData } from '../../models/AgentApi/Contract/freecard-data';
import { GetFreecardDataRequest as AgentApiModelsGetFreecardDataRequest } from '../../models/AgentApi/Models/get-freecard-data-request';

export interface ApiAgentGetFreecardDataPost$Params {

/**
 * language interface. if not filled in - default language
 */
  lang?: string;
      body?: AgentApiModelsGetFreecardDataRequest
}

export function apiAgentGetFreecardDataPost(http: HttpClient, rootUrl: string, params?: ApiAgentGetFreecardDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractFreecardData>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetFreecardDataPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractFreecardData>;
    })
  );
}

apiAgentGetFreecardDataPost.PATH = '/api/Agent/GetFreecardData';
